const LoadingSpinner = () => {
  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{
        zIndex: 2000,
        backgroundColor: 'rgba(0,0,0,0.4)',
      }}
    >
      <div className="spinner-border text-light" role="status" />
    </div>
  );
};

export default LoadingSpinner;
